/* Copyright (c) 2016-2023 Planticle Pty Ltd */
"use strict";

function queue(batchSize, delay, process, completion) {
	var q = [];
	var timer;
	var complete = false;

	function add(x) {
		if(complete) {
			throw new Error("Can't add job to finished queue");
		}
		q.push(x);

		if(!timer) {
			timer = setTimeout(processBatch, 0);
		}
	}

	function finish() {
		complete = true;
		if(!timer) {
			completion();
		}
	}

	function processBatch() {
		var size = Math.min(q.length, batchSize);

		var batch = q.slice(0, size);
		q = q.slice(size);

		batch.forEach(process);

		if(q.length > 0) {
			timer = setTimeout(processBatch, delay);
		} else {
			timer = null;
			if(complete) {
				completion();
			}
		}
	}

	return {
		add: add,
		finish: finish
	};
}

export default {
	queue: queue
};
